<template>
    <v-dialog v-model="dialog">
        <v-card>
            <div class="flex-center" style="height: 80svh">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    @click="previous"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6 chevron left"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15.75 19.5 8.25 12l7.5-7.5"
                    />
                </svg>

                <img
                    v-if="imagenactual != null"
                    :key="imagenactual.url"
                    :src="imagenactual.url"
                    class="image-visor"
                />

                <svg
                    @click="next"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6 chevron right"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="m8.25 4.5 7.5 7.5-7.5 7.5"
                    />
                </svg>
            </div>
        </v-card>
    </v-dialog>
</template>
<style scoped>
.image-transition-enter-active,
.image-transition-leave-active {
    transition: transform 1s;
}
.image-transition-enter, .image-transition-leave-to /* .image-transition-leave-active in <2.1.8 */ {
    transform: translateX(
        100%
    ); /* Initial position for entering and exiting slides */
}

.image-visor {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
    transition: opacity 0.5s;
}
.right {
    right: 0;
}
.left {
    left: 0;
}
.chevron {
    color: #5f5f5f;
    opacity: 0.5;
    position: absolute;
    transition: opacity 0.5s;
    cursor: pointer;
}
.chevron:hover {
    opacity: 1;
}
</style>
<script>
export default {
    props: ["imagenes", "start_index", "value"],
    data() {
        return {
            dialog: false,
            index: 0,
        };
    },
    created() {
        if (this.value != null) this.dialog = this.value;
        if (this.start_index != null) this.index = this.start_index;
    },
    watch: {
        value(val) {
            this.dialog = val;
            if (this.start_index != null) this.index = this.start_index;
        },
        dialog(val) {
            this.$emit("input", val);
        },
    },
    methods: {
        next() {
            if (this.imagenes != null) {
                this.index++;
                if (this.index >= this.imagenes.length) {
                    this.index = 0;
                }
            }
        },
        previous() {
            if (this.imagenes != null) {
                this.index--;
                if (this.index < 0) {
                    this.index = this.imagenes.length - 1;
                }
            }
        },
    },
    computed: {
        imagenactual: function () {
            if (this.imagenes != null) {
                if (this.imagenes.length > this.index) {
                    return this.imagenes[this.index];
                }
            }
        },
    },
};
</script>
